import instance from '../../api';
import { ErrorNotification } from '../../../Utils/data';

export interface DotRequestProgressListParams {
  page?: string | number;
  perPage?: string | number;
  driverUid?: string | number;
}

const toArray = (value: any): any[] => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.rows)) return value.rows;
  if (Array.isArray(value?.items)) return value.items;
  if (Array.isArray(value?.list)) return value.list;
  return [];
};

const toCount = (value: any, fallbackLength: number): number => {
  const candidates = [value?.count, value?.total, value?.totalCount, value?.meta?.total];
  const valid = candidates.find((item) => Number.isFinite(Number(item)));
  return valid !== undefined ? Number(valid) : fallbackLength;
};

export const dotRequestProgressApi = {
  async list(params: DotRequestProgressListParams) {
    try {
      const query = new URLSearchParams();
      query.append('page', String(params.page ?? 1));
      query.append('perPage', String(params.perPage ?? 10));

      if (params.driverUid !== undefined && params.driverUid !== null && params.driverUid !== '') {
        query.append('driverUid', String(params.driverUid));
      }

      const { data }: any = await instance(`dotRequestProgress/list?${query.toString()}`);

      const list = toArray(data);
      const count = toCount(data, list.length);

      return {
        data: list,
        count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data?.error?.message || error.message,
        });
      }
    }
  },

  async session(sessionId: string | number | undefined) {
    try {
      if (!sessionId) return;
      const { data }: any = await instance(`dotRequestProgress/session/${sessionId}`);
      return data?.data ?? data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data?.error?.message || error.message,
        });
      }
    }
  },
};
